export var chartOptions = function chartOptions(theme) {
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    chart: {
      height: 360,
      type: 'column',
      backgroundColor: theme.colors.background
    },
    xAxis: {
      visible: true,
      categories: []
    },
    yAxis: {
      title: {
        text: 'Rentabilidad'
      }
    },
    series: [],
    title: {
      text: ''
    },
    plotOptions: {
      column: {
        dataLabels: {
          format: "{y:.2f}%",
          enabled: true,
          crop: false,
          overflow: 'none',
          color: '#000'
        }
      },
      series: {
        pointPadding: 0,
        groupPadding: 0.1,
        borderWidth: 0,
        shadow: false
      }
    },
    tooltip: {
      pointFormat: "{point.y:.2f}%"
    }
  };
};